import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import resources from '../../../services';
import Btn from '../../../ui/Btn';
import { Field } from '../../../ui/Field';
import Select from 'react-select';
import UpdatePage from '../../../composents/UpdatePage';

const title = 'Cities';
const headers = {
	icon: 'feather icon-edit',
	title: title,
	description: 'update of city',
	breadcrumbs: [
		{
			title: title,
			link: '/hydrodrip/cities',
		},
	],
};

export default function EditCity() {
	const [loader, setLoader] = useState(false),
		[data, setData] = useState({}),
		[errors, setErrors] = useState({}),
		[country, setCountry] = useState(null),
		[countries, setContries] = useState(),
		[fail, setFail] = useState(false),
		[loading, setLoading] = useState(true),
		{ id } = useParams();

	async function onGet() {
		setLoading(true);
		let res = await resources.city
			.readOne(id)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (res.status === 200) {
			setData(res.data);
		} else if (res.status === 403) {
			setFail(true);
		}

		let cus = await resources.country
			.read('all')
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (cus.status === 200) {
			let a = [];
			cus.data.docs.forEach((el) => {
				if (res.data.country === el.id) {
					setCountry({
						value: el.id,
						label: el.name,
					});
				}
				a.push({
					value: el.id,
					label: el.name,
				});
			});
			setContries(a);
		}

		setLoading(false);
	}

	useEffect(() => {
		onGet();
	}, [id]);

	/**
	 * @param {React.FormEvent<HTMLFormElement>} e
	 */
	async function onUpdate(e) {
		e.preventDefault();
		setLoader(true);
		setErrors({});
		let formData = new FormData(e.target);
		let object = {};
		formData.forEach((value, key) => (object[key] = value));
		if (country) {
			object.country = country.value;
		}

		let res = await resources.city
			.update(id, object)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (res.status === 200) {
			sessionStorage.setItem('success', true);
			window.location.replace('/hydrodrip/cities');
		} else if (res.status === 422) {
			setErrors(
				res.data.errors.reduce((acc, error) => {
					return { ...acc, [error.field]: error.message };
				}, {})
			);
		} else if (res.status === 403) {
			setErrors({ not_autorized: true });
		}
		setLoader(false);
	}

	return (
		<UpdatePage
			show_error={errors['not_autorized']}
			loading={loading}
			fail={fail}
			headers={headers}
		>
			<form onSubmit={onUpdate}>
				<div className="row justify-content-center mt-3 mb-3">
					<div className="col-lg-6 ">
						<div className="card">
							<div className="card-header">
								<h5>Information</h5>
							</div>
							<div className="card-body">
								<div className="form-group mb-3">
									<label
										htmlFor="exampleInputEmail1"
										className="form-label"
									>
										Country{' '}
										<span style={{ color: 'red' }}>*</span>
									</label>
									<Select
										onChange={(e) => setCountry(e)}
										options={countries}
										value={country}
										isSearchable
										isClearable
										required
										className={
											errors['country']
												? ' is-invalid'
												: ''
										}
									/>
									{errors['country'] && (
										<div className="invalid-feedback">
											{errors['country']}
										</div>
									)}
								</div>

								<Field
									name="name"
									className="mb-3"
									error={errors['name']}
									defaultValue={data?.name}
									required
								>
									City name
								</Field>

								<Field
									name="code_1"
									type="number"
									className="mb-3"
									error={errors['code_1']}
									defaultValue={data?.code_1}
									required
								>
									City code 1
								</Field>

								<Field
									name="code_2"
									className="mb-3"
									error={errors['code_2']}
									defaultValue={data?.code_2}
									required
								>
									City code 2
								</Field>

								<Field
									name="description"
									type="textarea"
									defaultValue={data?.description}
									error={errors['description']}
									className="mb-3"
								>
									Description
								</Field>

								<div className="row ">
									<div className="col-lg-12">
										<div className="d-grid gap-2">
											<Btn
												class="btn waves-effect waves-light btn-primary"
												onLoad={loader}
											>
												<i className="feather icon-save"></i>{' '}
												Submit
											</Btn>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</UpdatePage>
	);
}
